var render, staticRenderFns
import script from "./CaudalChart.ts?vue&type=script&lang=ts&external"
export * from "./CaudalChart.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43e670a3')) {
      api.createRecord('43e670a3', component.options)
    } else {
      api.reload('43e670a3', component.options)
    }
    
  }
}
component.options.__file = "src/Modules/Cups/components/charts/CaudalChart/CaudalChart.vue"
export default component.exports